/**
 * Describes Api responses codes meanings for verifying activation link phase
 * @property {string} Invalid "Siganture is invalid or account is already activated"
 * @property {string} Expired "Activation link is expired and email was resent"
 * @property {string} Valid "Activation link is valid"
 */

export enum ResponseCodeEnum{
    Invalid= 403,
    Expired =419,
    Valid =200
}